import React from 'react'
import Icon from '@dustin-web/microsite-components/src/icon'
import { GetContactQuery } from '@dustin-web/microsite-data/src/graphql/product/generated/graphql-types'
import { GET_CONTACT } from '@dustin-web/microsite-data/src/graphql/product/get-contact.graphql'
import { useGraphql } from '@dustin-web/microsite-data/src/hooks'
import { useAuth } from '@dustin-web/microsite-components/src/auth'
import Link from 'next/link'
import ScrollContainer from '@dustin-web/microsite-components/src/scroll-container'
import useMenuItems from './hooks/useMenuItems'
import { useHeaderContext } from './header-context'
import classNames from 'classnames'
import { useTranslations } from '@dustin-web/microsite-components/src/hooks'
import AccountMenuContainer from './header-account-menu-container'

// Temp

const HeaderIconMenu = () => {
  const { mobile } = useHeaderContext()
  const { isAuthenticated, userData } = useAuth()
  const { translate } = useTranslations()

  const { data, error, isValidating } = useGraphql<GetContactQuery>(GET_CONTACT, {
    context: {
      skip: !isAuthenticated,
    },
  })

  const { categoryItems } = useMenuItems({
    visibility: data?.contact?.visibility,
  })

  if (isValidating || error) {
    return null
  }

  const contact = data?.contact

  return (
    <div>
      {isAuthenticated && (
        <div
          className={classNames('c-mobile-header-menu', {
            'u-px-16 c-mobile-header-menu--active c-mobile-header-menu--myaccount':
              mobile.showMyAccount,
          })}>
          <div className="c-mobile-header-menu__content d-flex flex-column">
            <div>
              <div className="d-flex">
                <h2 className="u-mr-16">{translate('MyAccount')}</h2>
                <Icon name="user" />
              </div>
              <div className="u-pb-16">
                <div className="no-mouseflow-dom">
                  {!!contact && contact.firstName} {!!contact && contact.lastName}
                </div>
              </div>
            </div>
            {!userData?.isPunchout && (
              <ScrollContainer height="60vh" className="u-pl-0" gradientColor="dark-gray">
                <div className="u-pb-16 u-mb-40 u-fs-20">
                  {categoryItems.map((categoryItem, index) => (
                    <React.Fragment key={index}>
                      <Link
                        prefetch={false}
                        href={categoryItem.pageName}
                        className="u-decoration-none">
                        <div className="u-py-8">
                          {/* <a style={{ textDecoration: 'none' }}> */}
                          <div
                            className={categoryItem.active ? `u-fw-bold ${'u-color-white'}` : ''}>
                            {categoryItem.title}
                          </div>
                          {/* </a> */}
                        </div>
                      </Link>

                      {categoryItem.items.map((item, index) => (
                        <Link
                          prefetch={false}
                          href={item.pageName}
                          style={{ textDecoration: 'none' }}
                          key={index}>
                          <div
                            className={
                              item.active
                                ? `u-fw-bold ${'u-color-white'} u-py-8 u-pl-16 u-fs-16`
                                : 'u-py-8 u-pl-16 u-fs-16'
                            }>
                            {item.title}
                          </div>
                        </Link>
                      ))}
                    </React.Fragment>
                  ))}
                </div>
              </ScrollContainer>
            )}
          </div>
          <div className="c-mobile-header-menu__footer u-px-0">
            <div className="col-12 u-px-0">
              <AccountMenuContainer />
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default HeaderIconMenu
